import { IRental } from '../../../ts/interface/rental.interface';

const getStationCoords = (rental: IRental) => {
  const { end, start } = rental;
  if (!start.station?.id) return [];

  if (start.station?.id === end?.station?.id || !end?.station?.id) {
    // don't make two markers if locations are the same or if rental hasn't ended
    return [
      {
        id: start.station?.id,
        lat: start.station?.latitude,
        long: start.station?.longitude,
      },
    ];
  }

  return [
    {
      id: start.station?.id,
      lat: start.station?.latitude,
      long: start.station?.longitude,
    },
    {
      id: end.station?.id,
      lat: end.station?.latitude,
      long: end.station?.longitude,
    },
  ];
};

export default getStationCoords;
